import MembershipPage from './MembershipPage';

export default MembershipPage;
